/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { ActionContext, Module } from 'vuex';
import store from '@/store';
import RootStateType from '@/store/types';
import generateMutations, {
  UPDATE_STATE_TYPE,
} from '@/store/generate-mutations';
import { getCashActivityDetail } from '@/api/rewarding';
import { getActivityUndertakeType, getVerifyIdentityTitleLatterPartText } from '@/shared/activity-undertake';
import { StateType } from './types';

const storeModule: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    cashActivityMatch: false,
    idCardActivityTitle: '',
    /** 若是营销活动场景，则需要读取页面配置数据 */
    isLoadingActivityConfig: !!getActivityUndertakeType(),
    /** 是否应该显示联系人导入图标 */
    shouldShowContactImportIcon: undefined,
    /** 联系人导入权限状态，用于曝光埋点 authType */
    contactImportAuthType: undefined,
  },
  actions: {
    // 获取现金活动详情
    async getCashActivityDetail(
      context: ActionContext<StateType, RootStateType>,
    ): Promise<void> {
      try {
        const { match, remind } = await getCashActivityDetail();
        if (match) {
          await context.dispatch(UPDATE_STATE_TYPE, {
            idCardActivityTitle: remind,
            cashActivityMatch: match,
          });
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.resolve();
      }
    },
    async updateActivityConfigRelateDisplay(
      context: ActionContext<StateType, RootStateType>,
    ): Promise<void> {
      await context.dispatch(UPDATE_STATE_TYPE, {
        idCardActivityTitle: getVerifyIdentityTitleLatterPartText(),
        isLoadingActivityConfig: false,
      });
    },
  },
};

store.registerModule('verifyCredit', generateMutations(storeModule));

export const verifyCreditDispatchActions : {
  updateActivityConfigRelateDisplay: () => Promise<void>;
} = {
  updateActivityConfigRelateDisplay:
    (): Promise<void> => store.dispatch('verifyCredit/updateActivityConfigRelateDisplay') as unknown as Promise<void>,
};
